//BuyingBookDetails.jsx
// TODO - Completion of Buy on Think5Whys Wallet Payment
// TODO - Completion of Buy on Think5Whys Onlie Payment Gateway
// TODO - Completion of GiftIt after Payment 
// TODO - Showing Collection, Agrregate Price on Collection 
// TODO - In GiftCoupon collection adding isBookCollection, isSeriesCollection
// TODO - In GiftCoupons Table adding new fields (array type) to store individual books and series in the separate collections
// TODO - Referal Capture for MLM Captupre
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Input, { Textarea } from '../../components/utils/Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookAtlas, faGifts, faCertificate, faCheck, faClipboardCheck, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import './styles/BookShelfListComponent.css';
import Tooltip from '../../components/utils/Tooltip';
import { generateGiftCouponCode} from '../../components/GenerateGiftCouponCode';
import { GenerateBookOrderNumber} from '../../components/GenerateThink5whysCode';
import { logout } from "../../redux/actions/authActions";


// import razorpaysleek from '../../assets/pageimages/razorpaysleek.png';
// import paymentgateways from '../../assets/pageimages/paymentgateways.png';

const BuyingBookDetails = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const location = useLocation();

    const isLoggedIn = authState?.isLoggedIn || false;

    const dispatch = useDispatch();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    };

    useEffect(() => {
        //Stopping Infinite Loop
    }, [location.state.bookId]);
    // console.log("location ",location);
    
    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    
    const [userCode, setUserCode] = useState(authState.user.think5whyscode);
    const [bookId, setBookId] = useState(location.state.bookId);
    const [bookData, setBookData] = useState(location.state.bookData);
    const [hasPurchased, setHasPurchased] = useState(location.state.hasPurchased);
    const [isFree, setIsFree] = useState(bookData.isFree);
    const [isCollection, setIsCollection] = useState(bookData.isCollection);
    const [collectionToSave, setCollectionToSave] = useState(location.state.collectionToSave);

    // console.log("Buying BookDetails Location BookData ", bookData);
    // console.log("Buying BookDetails Location collectionToSave ", collectionToSave);
    // console.log("isCollection ", isCollection ? "true" : "false");
    // console.log("isFree ",isFree);

    const [coverPrice, setCoverPrice] = useState(bookData.coverPrice);
    const [offerPrice, setOfferPrice] = useState(bookData.offerPrice);
    const [salesPrice, setSalesPrice] = useState(bookData.offerPrice);
    const [discountedPrice, setDiscountedPrice] = useState(bookData.discountedPrice);
    const splPrice = Math.round(bookData.offerPrice * 0.92);
    const [paymentAmount, setPaymentAmount] = useState(offerPrice);
    const [paymentMode, setPaymentMode] = useState('Online');
    const [insufficientBalance, setInsufficientBalance] = useState(false);
    const [customerName, setCustomerName] = useState(authState.user.name);
    const [purchaseDate, setPurchaseDate] = useState(new Date());
    const [qty, setQty] = useState(1);

    const [isGifted, setIsGifted] = useState(0);
    const [giftCouponMasterId, setGiftCouponMasterId] = useState('');
    const [giftCouponCode, setGiftCouponCode] = useState('');
    const [giftCouponIsRedeemed, setGiftCouponIsRedeemed] = useState('');
    const [corpCode, setCorpCode] = useState(10000000);
    const [gifterType, setGifterType] = useState('');
    const [entityName, setEntityName] = useState('');
    const [employeeCode, setEmployeeCode] = useState('');
    const [giftFor, setGiftFor] = useState('');
    const [giftMessage, setGiftMessage] = useState("Happy reading!");
    const [gifterName, setGifterName] = useState('');
    const [gifterSignatureLine, setGifterSignatureLine] = useState("All the best!!");
    const [giftThankYouMessage, setGiftThankYouMessage] = useState("Thank You!");
    const [redeemClicked, setRedeemClicked] = useState(false);
    const [giftCouponRedeemClicked, setGiftCouponRedeemClicked] = useState(false);
    const [corpPassRedeemClicked, setCorpPassRedeemClicked] = useState(false);
    const [bookClubTokenRedeemClicked, setBookClubTokenRedeemClicked] = useState(false);
    const [myCouponStatus, setMyCouponStatus] = useState(false);
    const [couponStatusMsg, setCouponStatusMsg] = useState('');

    const [hasDiscountCouponClicked, setHasDiscountCouponClicked] = useState(false);
    const [hasReferralCodeClicked, setHasReferralCodeClicked] = useState(false);
    const [hasRedeemGiftClicked, setHasRedeemGiftClicked] = useState(false);
    const [hasCorpPassClicked, setHasCorpPassClicked] = useState(false);
    const [hasBookClubTokenClicked, setHasBookClubTokenClicked] = useState(false);
    const [buyingMethod, setBuyingMethod] = useState('Direct');

    const [referralCode, setReferralCode] = useState('');
    const [referralName, setReferralName] = useState('');
    const [referralEmail, setReferralEmail] = useState('');
    const [referralId, setReferralId] = useState(null);
    const [referralUserLevel, setReferralUserLevel] = useState(0);
    // const [referralParentCode, setReferralParentCode] = useState('');
    // const [referralParentName, setReferralParentName] = useState('');
    // const [referralParentId, setReferralParentId] = useState(null);
    const [referralCodeMsg, setReferralCodeMsg] = useState('');
    const [verifyReferralCodeButtonClicked, setVerifyReferralCodeButtonClicked] = useState(false);
    const [mlmAdvisor, setMLMAdvisor] = useState('');
    const [mlmAdvisorCheckMsg, setMLMAdvisorCheckMsg] = useState(null);
    const [userLevel, setUserLevel] = useState(0);
    const [discountCouponCode, setDiscountCouponCode] = useState('');
    const [discountCouponIsApplied, setDiscountCouponIsApplied] = useState(0);
    const [discountCouponMasterId, setDiscountCouponMasterId] = useState('');
    const [discountAmount, setDiscountAmount] = useState(0);
    const [discountPercent, setDiscountPercent] = useState(0.00);
    const [discountCurrency, setDiscountCurrency] = useState("INR");
    const [discountCouponRedeemedBy, setDiscountCouponRedeemedBy] = useState(null);
    const [isValidDiscountCoupon, setIsValidDiscountCoupon] = useState('');
    const [verifyDiscountCouponButtonClicked, setVerifyDiscountCouponButtonClicked] = useState(false);
    const [discountCouponIsRedeemed, setDiscountCouponIsRedeemed] = useState(0);
    const [discountCouponStatus, setDiscountCouponStatus] = useState(false);
    const [discountCouponStatusMsg, setDiscountCouponStatusMsg] = useState('');

    const [agentName, setAgentName] = useState('');

    const [referralCodeStatus, setReferralCodeStatus] = useState(false);
    const [referralCodeStatusMsg, setReferralCodeStatusMsg] = useState('');

    const [hasFlashReferralCodeClicked, setHasFlashReferralCodeClicked] = useState(false);
    const [flashReferralCodeStatus, setFlashReferralCodeStatus] = useState(false);
    const [flashReferralCodeStatusMsg, setFlashReferralCodeStatusMsg] = useState('');
    const [flashReferralCode, setFlashReferralCode] = useState('');
    const [flashReferralId, setFlashReferralId] = useState(null);
    const [flashReferralName, setFlashReferralName] = useState('');
    const [flashReferralEmail, setFlashReferralEmail] = useState('');
    const [flashReferralCodeMsg, setFlashReferralCodeMsg] = useState('');
    const [verifyFlashReferralCodeButtonClicked, setVerifyFlashReferralCodeButtonClicked] = useState(false);

    const [hasReadfluencerCodeClicked, setHasReadfluencerCodeClicked] = useState(false);
    const [readfluencerCodeStatus, setReadfluencerCodeStatus] = useState(false);
    const [readfluencerCodeStatusMsg, setReadfluencerCodeStatusMsg] = useState('');
    const [readfluencerCode, setReadfluencerCode] = useState('');
    const [readfluencerId, setReadfluencerId] = useState(null);
    const [readfluencerName, setReadfluencerName] = useState('');
    const [readfluencerEmail, setReadfluencerEmail] = useState('');
    const [readfluencerCodeMsg, setReadfluencerCodeMsg] = useState('');
    const [verifyReadfluencerCodeButtonClicked, setVerifyReadfluencerCodeButtonClicked] = useState(false);

    const [giftItClicked, setGiftItClicked] = useState(false);
    const [giftItSaveStatus, setGiftItSaveStatus] = useState(true);
    const [giftItErrorMsg, setGiftItErrorMsg] = useState('');
    const [giftedByWallet, setGiftedByWallet] = useState(false);
    const [giftedOnline, setGiftedOnline] = useState(false);

    const [buyingClicked, setBuyingClicked] = useState(false);
    const [discountedBuyingClicked, setDiscountedBuyingClicked] = useState(false);

    const [addFreeClicked, setAddFreeClicked] = useState(false);

    const [walletBuyingClicked, setWalletBuyingClicked] = useState(false);
    const [walletBalanceAmount, setWalletBalanceAmount] = useState(0.00);
    const [walletBalancePoints, setWalletBalancePoints] = useState(0);
    const [walletLastUpdated, setWalletLastUpdated] = useState();
    const [walletLastUpdatedRemarks, setWalletLastUpdatedRemarks] = useState('');

    const [onlinePaymentClicked, setOnlinePaymentClicked] = useState(false);
    const [pgBuyingClicked, setPgBuyingClicked] = useState(false);
    const [pgPaymentStatus, setPgPaymentStatus] = useState(false);
    const [pgResponseData, setPgResponseData] = useState(null);
    const [paymentStatusMessage, setPaymentStatusMessage] = useState(null);
    const [orderNumber, setOrderNumber] = useState(GenerateBookOrderNumber());
    const [invoice, setInvoice] = useState(GenerateBookOrderNumber());

    const [error, setError] = useState('');
    const [verifyGiftCouponButtonClicked, setVerifyGiftCouponButtonClicked] = useState(false);

    const [navigatedFromRedeemNow, setNavigatedFromRedeemNow] = useState(0);
    const [navigatedFromDiscountCouponApplied, setNavigatedFromDiscountCouponApplied] = useState(0);
    const [navigatedFromWalletPayment, setNavigatedFromWalletPayment] = useState(0);
    const [navigatedFromOnlinePayment, setNavigatedFromOnlinePayment] = useState(0);
    const [navigatedFromGiftIt, setNavigatedFromGiftIt] = useState(0);

    const [highlightStates, setHighlightStates] = useState({});
    const [bookDescStates, setBookDescStates] = useState({});

    const [navigatedFromAddFree, setNavigatedFromAddFree] = useState(0);

    const allowedSelfReferrerCodes = ['TU243AM5850150', 'TU243BM5850150', 'TU2454M5850150'];
    const dollarPriceMultiply = bookData.dollarPriceMultiplyFactor/bookData.inrToDollarConversionRate;

    
    const [referrerHasPurchased, setReferrerHasPurchased] = useState(false);
    const [referrerHasPurchasedMsg, setReferrerHasPurchasedMsg] = useState('');

    const handleRedeemGiftClick = () => {
        setRedeemClicked(true);
        setHasDiscountCouponClicked(false);
        setHasReferralCodeClicked(false);
        setHasFlashReferralCodeClicked(false);
        setHasReadfluencerCodeClicked(false);
        setHasRedeemGiftClicked(true);
        setHasCorpPassClicked(false);
        setHasBookClubTokenClicked(false);
    };

    const handleRedeemCorpPassClick = () => {
        setRedeemClicked(true);
        setHasDiscountCouponClicked(false);
        setHasReferralCodeClicked(false);
        setHasFlashReferralCodeClicked(false);
        setHasReadfluencerCodeClicked(false);
        setHasRedeemGiftClicked(false);
        setHasCorpPassClicked(true);
        setHasBookClubTokenClicked(false);
    };

    const handleRedeemBookClubTokenClick = () => {
        setRedeemClicked(true);
        setHasDiscountCouponClicked(false);
        setHasReferralCodeClicked(false);
        setHasFlashReferralCodeClicked(false);
        setHasReadfluencerCodeClicked(false);
        setHasRedeemGiftClicked(false);
        setHasCorpPassClicked(false);
        setHasBookClubTokenClicked(true);
    };

    const handleRedeemNow = () => {
        setNavigatedFromRedeemNow(1);
        setIsGifted(1);
    };

    useEffect(() => {
        if (navigatedFromRedeemNow) {
            // console.log("navigatedFromRedeemNow before setting from useEffect", navigatedFromRedeemNow);
            saveBuyNow();
        }
    }, [navigatedFromRedeemNow]);

const walletPaymentClicked = (orderNumber, purchaseDate, customerName, bookTitle, paymentAmount) => {
    setNavigatedFromWalletPayment(1);
    setInvoice(`
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; border: 1px solid #ddd; padding: 20px; border-radius: 10px;">
            <h2 style="font-size: 24px; font-weight: 600; color: #333; margin-bottom: 20px; text-align: center;">Order Summary</h2>
            <div style="color: #555; line-height: 1.6;">
                <p><strong>Order Number:</strong> ${orderNumber}</p>
                <p><strong>Order Date:</strong> ${purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                <p><strong>Customer Name:</strong> ${customerName}</p>
                <p><strong>Customer Address:</strong> Online Digital Product</p>
                <p><strong>Item:</strong> ${bookTitle}</p>
                <p><strong>Item Description:</strong> ${bookTitle}</p>
                <p><strong>HSN Code:</strong> ${bookData.hsnCode}</p>
                <p><strong>GST Rate:</strong> ${bookData.gstRate}</p>
                <p><strong>Qty:</strong> 1 </p>
                <p><strong>Rate:</strong> ₹${paymentAmount}</p>
                <p><strong>Bill Amount:</strong> ₹${paymentAmount}</p>
                <p><strong>Amount Paid:</strong> ₹${paymentAmount}</p>
                <p><strong>Payment Method:</strong>{'Digital through Think5Whys Prepaid Wallet'}</p>
                <p><strong>Terms & Conditions:</strong> ${bookData.tnc}</p>
                </div>
        </div>
    `);
};

    useEffect(() => {
        if (navigatedFromWalletPayment) {
            // console.log("setNavigatedFromWalletPayment before setting from useEffect", navigatedFromWalletPayment);
            saveBuyNow();
        }
    }, [navigatedFromWalletPayment]);

    const fetchMyGiftCoupon = useCallback((giftCouponCode, corpCode, bookIdForGift, giftSource, giftCouponType) => {
        const config = {
            url: "/giftcoupon",
            method: "get",
            headers: { Authorization: authState.token },
            params: { couponNumber: giftCouponCode, corpCode: corpCode, bookId: bookIdForGift }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Response received:", response);
                if (response && response.coupon) {
                    // console.log('Coupon found:', response.coupon);
                    // setCouponStatusMsg(`Coupon Code ${response.coupon.couponNumber} found for Corporate Code ${response.coupon.corpCode}`);
                    setMyCouponStatus(true);
                    setCouponStatusMsg(`Congratulation!! ${giftCouponType} ${response.coupon.couponNumber} Successfully Verfied and is Available for use in ${bookData.bookTitle}  ! 😊`);
                    setGiftCouponMasterId(response.coupon._id);
                    setGifterType(response.coupon.gifterType);
                    setEntityName(response.coupon.entityName);
                    setEmployeeCode(response.coupon.employeeCode);
                    setGifterName(response.coupon.gifterName);
                    setGiftFor(response.coupon.giftFor);
                    setGiftMessage(response.coupon.giftMessage);
                    setGifterSignatureLine(response.coupon.gifterSignatureLine);
                    setGiftCouponIsRedeemed(response.coupon.isRedeemed);
                    setSalesPrice(response.coupon.paymentAmount);
                    setPaymentAmount(response.coupon.paymentAmount);
                    setBuyingMethod(giftSource);
                    // console.log("setCouponStatusMsg:", setCouponStatusMsg);
                    // console.log("setMyCouponStatus:", setMyCouponStatus);
                } else {
                    // console.log('Coupon not found');
                    // setCouponStatusMsg(`Coupon Code ${config.params.couponNumber} not found for Corporate Code ${config.params.corpCode}`);
                    setCouponStatusMsg(`Sorry!! ${giftCouponType} ${config.params.couponNumber} not Found!? for ${bookData.bookTitle} 😔`);
                    setMyCouponStatus(false);
                }
            })
            .catch(error => {
                console.error("Error Fetching ", giftCouponType);
                setMyCouponStatus(false);
            });
    }, [fetchData, setMyCouponStatus]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchMyGiftCoupon]);


    const handleRechargeWallet = () => {
        // navigate('/wallet-topup', { state: { bookData: bookData, paymentAmount: paymentAmount, gifterId: authState.user._id, gifterName: authState.user.name, giftFor: giftFor, giftMessage: giftMessage, gifterSignatureLine: gifterSignatureLine } });
        navigate('/wallet-topup', { state: { title: bookData.bookTitle, paymentAmount: paymentAmount - walletBalanceAmount, gifterId: authState.user._id, gifterName: authState.user.name, giftFor: giftFor, giftMessage: giftMessage, gifterSignatureLine: gifterSignatureLine } });
    };

    const handlePayNow = () => {
        // navigate('/buying-thankyou', { state: { bookData: bookData } });
    };

    const handleBuyBook = () => {
        setBuyingClicked(true);
    };

    // const handleAddFreeBook = (bookData) => {
    //     setAddFreeClicked(true);
    // };

    const handleAddFreeClicked = () => {
        // console.log("handleAddFreeClicked");
        setNavigatedFromAddFree(1);
        setAddFreeClicked(true);
        // setOrderNumber(orderNumber());
    };

    useEffect(() => {
        if (navigatedFromAddFree) {
            // console.log("setNavigatedFromAddFree before setting from useEffect", setNavigatedFromAddFree);
            saveBuyNow();
        }
    }, [navigatedFromAddFree]);

    const handleBuyNowWallet = () => {
        saveBuyNow(isGifted);
    };

    const handleBuyNowOnline = () => {
        saveBuyNow(isGifted);
    };

    // const saveBuyNow = async () => {
    // console.log("giftItClicked", giftItClicked);
    // console.log("isGifted", isGifted);
    // if (giftItClicked) {
    //     setIsGifted(1);
    //     const navigatedFromGiftIt = 1;
    // } else {
    //     const navigatedFromGiftIt = 0;
    // }
    // console.log("isGifted", isGifted);

    const saveBuyNow = async () => {
        // console.log("Inside saveBuyNow BookData", bookData);

        // const userId = userId;
        const currentDate = new Date();
        const subscriptionEndDateFromNow = new Date(currentDate);
        subscriptionEndDateFromNow.setFullYear(currentDate.getFullYear() + 3);
        if (redeemClicked) {
            const navigatedFromRedeemNow = 1;
        } else {
            const navigatedFromRedeemNow = 0;
        }
        // console.log("navigatedFromRedeemNow",navigatedFromRedeemNow);
        // console.log("isGifted",isGifted);

        if (walletPaymentClicked) {
            const navigatedFromWalletPayment = 1;
        } else {
            const navigatedFromWalletPayment = 0;
        }
        // if (onlinePaymentClicked) {
        //     const navigatedFromOnlinePayment = 1;
        // } else {
        //     const navigatedFromOnlinePayment = 0;
        // }
        if (addFreeClicked) {
            const navigatedFromAddFree = 1;
        } else {
            const navigatedFromAddFree = 0;
        }
        if (navigatedFromRedeemNow) {
            setIsGifted(1);
        }
        // console.log("navigatedFromRedeemNow isGifted", navigatedFromRedeemNow,"  ",isGifted)
        const requestData = {
            userId: userId,
            userCode: userCode,
            userName: userName,
            userLevel: referralUserLevel + 1,
            advisorId: referralId,
            advisorCode: referralCode,
            advisorName: referralName,
            advisorLevel: referralUserLevel,
            bookId: bookData._id,
            isT5W: bookData.isT5W,
            bookCode: bookData.bookCode,
            bookTitle: bookData.bookTitle,
            bookAuthor: bookData.bookAuthor,
            bookPages: bookData.bookPages,
            bookImage: bookData.bookImage,
            bookAPI: bookData.bookAPI,
            isSubscription: 0,
            subscriptionEndDate: subscriptionEndDateFromNow,
            purchaseDate: purchaseDate,
            isActive: 1,
            isDeleted: 0,
            language: bookData.language,
            isChildren: bookData.isChildren,
            bookCollectionName: bookData.bookCollectionName,
            lastPageRead: 1,
            bookSubject: bookData.subject,
            bookCategory: bookData.category,
            bookSubCategory: bookData.subCategory,
            remarks: "Buy",
            bookHighlight: '', 
            // bookHighlight: bookData.bookHighlight,
            displayIndex: bookData.displayIndex,
            hasAssignment: bookData.hasAssignment,
            hasCertificate: bookData.hasCertificate,
            hasExam: bookData.hasExam,
            hasPracticeTest: bookData.hasPracticeTest,
            coverPrice: bookData.coverPrice,
            offerPrice: bookData.offerPrice,
            hasDiscountedPrice: bookData.hasDiscountedPrice,
            discountedPrice: bookData.discountedPrice,
            salesPrice: salesPrice,
            discountCouponCode: discountCouponCode,
            discountCouponMasterId: discountCouponMasterId,
            discountCouponRedeemedBy: userId,
            discountAmount: bookData.offerPrice - bookData.discountedPrice,
            discountPercent: ((bookData.offerPrice - bookData.discountedPrice) / bookData.offerPrice) * 100,
            discountCurrency: "₹",
            paymentAmount: paymentAmount,
            paymentMode: paymentMode,
            paymentDate: new Date(),
            transactionId: "",
            paymentRemarks: "",
            isGifted: isGifted,
            giftCouponCode: giftCouponCode,
            corpCode: corpCode,
            entityName: entityName,
            employeeCode: employeeCode,
            isGifted: isGifted,
            giftFor: giftFor,
            giftMessage: giftMessage,
            gifterSignatureLine: gifterSignatureLine,
            gifterName: gifterName,
            giftThankYouMessage: giftThankYouMessage,
            giftCouponMasterId: giftCouponMasterId,
            giftedTo: authState.user.name,
            redeemedBy: userId,
            navigatedFromRedeemNow: navigatedFromRedeemNow,
            navigatedFromWalletPayment: navigatedFromWalletPayment,
            navigatedFromOnlinePayment: navigatedFromOnlinePayment,
            navigatedFromAddFree: navigatedFromAddFree,
            isAudioBook: bookData.isAudioBook,
            isFlipBook: bookData.isFlipBook,
            isPictureBook: bookData.isPictureBook,
            isTextBook: bookData.isTextBook,
            isTouchBook: bookData.isTouchBook,
            isVideoBook: bookData.isVideoBook,
            isCollection: bookData.isCollection,
            freeReads: bookData.freeReads,
            paidReads: bookData.paidReads,
            isDictaBook: bookData.isDictaBook,
            isTVBook: bookData.isTVBook,
            isARBook: bookData.isARBook,
            splRemarks: "",
            isMLM: bookData.isMLM,
            MLMCommissionStructure: bookData.MLMCommissionStructure,
            MLMCommission: 0,
            buyingMethod: buyingMethod,
            invoice: invoice,
            orderNumber: orderNumber,
            invoiceNumber: orderNumber,
            receiptNumber: orderNumber,
            currentStatus: "OUP",
            sellerDetails: bookData.sellerDetails,
            gstNumber: bookData.gstNumber,
            hsnCode: bookData.hsnCode,
            gstRate: bookData.gstRate,
            tnc: bookData.tnc,
            qty: qty,
            unit: "Pc",
            rate: salesPrice / qty,
            bbId: flashReferralId,
            bbCode: referralCode,
            bbName: flashReferralName,
            riId: readfluencerId,
            riCode: readfluencerCode,
            riName: readfluencerName,  
        };
// console.log("Request Data ",requestData, collectionToSave ? "Collection" : "No Collection", referralCodeStatus ? "Referral Code" : "No Referral Code");
        try {
            const config = { url: `/mybooks`, method: "post", data: { bookData: requestData, collectionData: collectionToSave, isMLMReferral: referralCodeStatus }, headers: { Authorization: authState.token } };
            await fetchData(config);
            navigate('/bookshelf');
        } catch (error) {
            console.error('An error occurred while fetching data:', error);
        }
    };

    const handleGiftNow = () => {
        // console.log("before setIsGifted ", setIsGifted, giftItClicked);
        setIsGifted(1);
        setGiftItClicked(true);
        // console.log("after setIsGifted ", setIsGifted, giftItClicked);
        saveGiftIt();
    };

    const handleGiftNowByWallet = () => {
        // console.log("I am inside handleGiftNowByWallet")
        setIsGifted(1);
        setGiftedByWallet(true);
        setGiftedOnline(false)
        saveGiftIt();
    };

    useEffect(() => {
        // console.log("State updated after giftNowByWallet: isGifted =", isGifted, "giftedByWallet =", giftedByWallet);
    }, [handleGiftNowByWallet]);

    const handleGiftNowOnline = () => {
        makePayment();
        // console.log("pgResponseData.status", pgResponseData.status);
        if (pgResponseData.status == "captured") {
            setIsGifted(1);
            setGiftedByWallet(false);
            setGiftedOnline(true);
            saveGiftIt();
        } else {
            setPaymentStatusMessage("Payment Unsuccessful");
        }
    };

    useEffect(() => {
        // console.log("State updated : isGifted =", isGifted, "giftedOnline =", giftedOnline);
    }, [isGifted, giftedByWallet, giftedOnline]);


    const saveGiftIt = async () => {
        // console.log("State updated inside  saveIt: isGifted =", isGifted, "giftedByWallet =", giftedByWallet);

        // const userId = authState.user._id;
        const currentDate = new Date();
        const subscriptionEndDateFromNow = new Date(currentDate);
        subscriptionEndDateFromNow.setFullYear(currentDate.getFullYear() + 3); // 3 Years
        const couponValidityDate = new Date(currentDate);
        couponValidityDate.setFullYear(currentDate.getFullYear() + 1); // 1 Years
        if (redeemClicked) {
            const navigatedFromRedeemNow = 1;
        } else {
            const navigatedFromRedeemNow = 0;
        }
        const requestData = {
            userId: userId,
            gifterType: "Ind",
            entityId: null,
            entityName: "",
            employeeCode: "",
            giftItem: "Book",
            bookId: bookData._id,
            bookCode: bookData.bookCode,
            bookTitle: bookData.bookTitle,
            seriesId: null,
            seriesType: "",
            seriesCode: "",
            seriesTitle: "",
            corpCode: corpCode,
            giftCouponCode: giftCouponCode,
            couponValidityDate: couponValidityDate,
            isGifted: giftItClicked ? 1 : 0,
            giftFor: giftFor,
            giftMessage: giftMessage,
            gifterName: authState.user.name,
            gifterSignatureLine: gifterSignatureLine,
            isRedeemed: 0,
            redeemedBy: null,
            dateRedeemed: null,
            giftedTo: "",
            giftThankYouMessage: "",
            isActive: 1,
            isDeleted: 0,
            remarks: "Created using GiftIt",
            giftValue: coverPrice,
            paymentAmount: paymentAmount,
            couponType: 1,
            purchaseDate: new Date(),
            giftedByWallet: true,   //giftedByWallet, TODO
            giftedOnline: giftedOnline,
            navigatedFromGiftIt: navigatedFromGiftIt,
            subscriptionEndDate: subscriptionEndDateFromNow,
            isCollection: bookData.isCollection,
        };
        // console.log('Gifting to be saved:', requestData);
        try {
            const config = { url: `/giftcoupon`, method: "post", data: requestData, headers: { Authorization: authState.token } };
            await fetchData(config);
            navigate('/giftit-igifted');
        } catch (error) {
            console.error('An error occurred while fetching data:', error);
            setGiftItSaveStatus(false);
            setGiftItErrorMsg("There is technical error in saving gifting data. Please retry.");
        }
    };

    const handleCouponGenerated = (code) => {
        setGiftCouponCode(code);
    };

    const handleDiscountCouponClick = () => {
        setHasDiscountCouponClicked(true);
        setHasReferralCodeClicked(false);
        setHasFlashReferralCodeClicked(false);
        setHasReadfluencerCodeClicked(false);
        setHasRedeemGiftClicked(false);
        setHasCorpPassClicked(false);
        setHasBookClubTokenClicked(false);
    };

    const handleReferralCodeClick = () => {
        setHasDiscountCouponClicked(false);
        setHasReferralCodeClicked(true);
        setHasFlashReferralCodeClicked(false);
        setHasReadfluencerCodeClicked(false);
        setHasRedeemGiftClicked(false);
        setHasCorpPassClicked(false);
        setHasBookClubTokenClicked(false);
    };

    const handleFlashReferralCodeClick = () => {
        setHasDiscountCouponClicked(false);
        setHasReferralCodeClicked(false);
        setHasFlashReferralCodeClicked(true);
        setHasReadfluencerCodeClicked(false);
        setHasRedeemGiftClicked(false);
        setHasCorpPassClicked(false);
        setHasBookClubTokenClicked(false);
    };

    const handleReadfluencerCodeClick = () => {
        setHasDiscountCouponClicked(false);
        setHasReferralCodeClicked(false);
        setHasFlashReferralCodeClicked(false);
        setHasReadfluencerCodeClicked(true);
        setHasRedeemGiftClicked(false);
        setHasCorpPassClicked(false);
        setHasBookClubTokenClicked(false);
    };

    const verifyDiscountCouponClick = () => {
        setDiscountAmount(0);    // As per 
    };

    const giftCouponValidationClicked = (giftCoupon, corpCode, bookIdForGift, giftSource, giftCouponType) => {
        const inputValue = giftCoupon;
        if (/^[a-zA-Z0-9]{13}$/.test(giftCoupon)) {
            // console.log("Valid giftCoupon", giftCoupon);
            fetchMyGiftCoupon(giftCoupon, corpCode, bookIdForGift, giftSource, giftCouponType);
        } else {
            setError('Please enter a valid 13-character alphanumeric ${giftCouponType}');
        }
    };

    const handleGiftCouponValidation = () => {
        setVerifyGiftCouponButtonClicked(true);
    };

    const discountCouponValidationClicked = (discountCoupon) => {
        const inputValue = discountCoupon;
        if (/^[a-zA-Z0-9]{12}$/.test(discountCoupon)) {
            // console.log("Valid discountCoupon", discountCoupon);
            fetchDiscountCoupon(discountCoupon);
        } else {
            setError('Please enter a valid 12-character alphanumeric discount coupon code');
        }
    };

    const handleDiscountCouponValidation = () => {
        setVerifyDiscountCouponButtonClicked(true);
    };

    const fetchDiscountCoupon = useCallback((discountCouponCode) => {
        const agentCode ='';
        const config = {
            url: "/discountcoupon/validateforfranchise",
            method: "post",
            headers: { Authorization: authState.token },
            data: { couponNumber: discountCouponCode, bookId: bookId, agentCode: agentCode }
        };
        // console.log("Request Payload for check discountCouponCode in Buying Book in MLM: ", { discountCouponCode, bookId, agentCode }); 

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Response received:", response);
                if (response && response.discountcoupon) {
                    // console.log('Coupon found:', response.discountcoupon);
                    setDiscountCouponStatus(true);
                    if (response.discountcoupon.isRedeemed === 1) {
                        setDiscountCouponStatusMsg(`Coupon Code ${response.discountcoupon.couponNumber} has already been redeemed. Use different coupon code!😊`);
                        setPaymentAmount(offerPrice);
                        setSalesPrice(offerPrice);
                    } else {
                        setDiscountCouponStatusMsg(`Coupon Code ${response.discountcoupon.couponNumber} is Valid & you can apply it to avail discount for this! 😊`);
                        setPaymentAmount(discountedPrice);
                        setSalesPrice(discountedPrice);
                    }
                    setDiscountCouponMasterId(response.discountcoupon._id);
                    setAgentName(response.discountcoupon.agentName);
                    setDiscountCouponIsRedeemed(response.discountcoupon.isRedeemed);
                    setBuyingMethod("FDC");
                } else {
                    setDiscountCouponStatusMsg(`Coupon Code ${config.params.couponNumber} not found for the Book ${bookData.bookTitle}!? 😔`);
                    setDiscountCouponStatus(false);
                }
            })
            .catch(error => {
                console.error("Error fetching coupon:", error);
                setDiscountCouponStatus(false);
            });
    }, [fetchData, setDiscountCouponStatus]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchDiscountCoupon]);

    const referralCodeValidationClicked = (referralCode, bookIdForReferral) => {
        if (/^TU[a-zA-Z0-9]{12}$/.test(referralCode)) {
            if (userCode === referralCode && !allowedSelfReferrerCodes.includes(referralCode)) {
                setError("You cannot be self referrer. Please use a different valid referral code than yours.");
            } else {
                fetchReferralCodeForBook(referralCode, bookIdForReferral);
                // console.log("Fetching Referrer Code for Book");
            }
        } else {
            setError('Please enter a valid 14-character Think5Whys DigiLearn Ambassador Referral ID starting with TU.');
        }
    };
    
    const handleReferralCodeValidation = () => {
        setVerifyReferralCodeButtonClicked(true);
    };

    const fetchReferralCode = useCallback((referralCode) => {
        // console.log("referralCode for API call ", referralCode);
        const config = {
            url: "/auth/verifyreferralcode",
            method: "post",
            headers: { Authorization: authState.token },
            data: { think5whyscode: referralCode }
        };

        fetchData(config)
            .then(response => {
                if (response && response.status) {
                    // console.log("referralCode found ", response);
                    setReferralName(response.t5wcode.name);
                    setReferralEmail(response.t5wcode.email);
                    setReferralId(response.t5wcode._id);
                    // hasReferrerPurchased(response.t5wcode._id, bookId),
                    setReferralCodeStatus(true);
                    setReferralCodeStatusMsg(`Referral Code ${referralCode} found! 😊`);
                    setBuyingMethod("MLM");
                } else {
                    // console.log("referralCode Not found");
                    setReferralCodeStatus(false);
                    setReferralCodeStatusMsg(`Referral Code ${referralCode} not found! 😔`);
                }
            })
            .catch(error => {
                // console.log("referralCode Not found!");
                setReferralCodeStatus(false);
                setReferralCodeStatusMsg(`Referral Code ${referralCode} not found! 😔`);
            });
    }, [fetchData, setReferralCodeStatus]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchReferralCode]);


    // const hasReferrerPurchased = asyn((referrerId, bookId) => {
    //     console.log("API call for hasReferrerPurchased: ", referrerId, bookId);
    //     const config = {
    //         url: "/mybooks/checkmlmreferrer",
    //         method: "post",
    //         headers: { Authorization: authState.token },
    //         data: { userId: referrerId, bookId: booId }
    //     };

    //     fetchData(config)
    //         .then(response => {
    //             if (response && response.purchased) {
    //                 console.log("referrer found ", response);
    //                 setReferrerHasPurchased(true);
    //                 setReferrerHasPurchasedMsg(`Referrer ${referralCode} has purchased and eligible to become Ambassador! 😔`);
    //             } else {
    //                 setReferrerHasPurchasedMsg(`Referrer ${referralCode} has not purchased yet! 😔`);
    //             }
    //         })
    //         .catch(error => {
    //             setReferrerHasPurchasedMsg(`Error checking Referrer ${referralCode} purchase! 😔`);
    //         });
    // }, [fetchData, setReferralCodeStatus]); 

    const fetchReferralCodeForBook = useCallback((referralCode, bookIdForReferral) => {
        // console.log("referralCode for API call ", referralCode, " for bookId ", bookIdForReferral);
        if (allowedSelfReferrerCodes.includes(referralCode)) {
            // console.log("allowed self referralCode for API call ", referralCode, " for bookId ", bookIdForReferral);
            setAllowedSelfReferralForBook(referralCode, bookIdForReferral);
            return;
        }
        const config = {
            url: "/mybooks/checkreferral",
            method: "post",
            headers: { Authorization: authState.token },
            data: { advisorCode: referralCode, bookId: bookIdForReferral }
        };
        // console.log("Request Payload for check referral code in Buying Book in MLM: ", { referralCode, bookIdForReferral }); 

        fetchData(config)
            .then(response => {
                if (response && response.status) {
                    // console.log("referralCode found ", response);
                    setReferralCodeStatus(true);
                    setReferralId(response.referralUser.userId);
                    setReferralName(response.referralUser.userName);
                    setReferralUserLevel(response.referralUser.userLevel);
                    // console.log("response.referralUser.userLevel ", response.referralUser.userLevel);
                    setSalesPrice(offerPrice);
                    setBuyingMethod("MLM");
                    setReferralCodeStatusMsg(`Referral Code ${referralCode} for ${bookData.bookTitle} found! 😊`);
                 
                    const userCodeInChart = referralCode;
                    const bookIdChart = bookIdForReferral;

                    // console.log("Referrer Code to be searched as userCode in MLM Chart: ",referralCode);
                    // console.log("Book Id to be searched in MLM Chart: ",bookIdChart);

                    // fetchMLMChart(userCodeInChart, bookIdChart);
                    // console.log("MLM Advisor from Chart: ", mlmAdvisor);
                } else {
                    // console.log("referralCode Not found");
                    setReferralCodeStatus(false);
                    setReferralCodeStatusMsg(`Referral Code ${referralCode} for ${bookData.bookTitle} not found! 😔 Make sure the Referral Code is valid and the Referrer has purchased this Book.`);
                }
            })
            .catch(error => {
                // console.log("referralCode Not found!");
                setReferralCodeStatus(false);
                setReferralCodeStatusMsg(`Referral Code ${referralCode} for ${bookData.bookTitle} not found! 😔 Make sure the Referral Code is valid and the Referrer has purchased this Book.`);
            });
    }, [fetchData, setReferralCodeStatus]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchReferralCodeForBook]);

    const setAllowedSelfReferralForBook = useCallback((referralCode, bookIdForReferral) => {
        if (referralCode === 'TU243AM5850150') {
            setReferralCodeStatus(true);
            setReferralId("65ed7e599dc48d2b0999f35d");
            setReferralName("Srishti Sinha");
            setReferralUserLevel(1);
            setSalesPrice(offerPrice);
            setBuyingMethod("MLM");
            setReferralCodeStatusMsg(`Setting Self Referral Code ${referralCode} for ${bookData.bookTitle}! 😊`);
        } else if (referralCode === 'TU243BM5850150') {
            setReferralCodeStatus(true);
            setReferralId("65eeb0b362e8020c10acdb1a");
            setReferralName("Sanjeev Kumar");
            setReferralUserLevel(1);
            setSalesPrice(offerPrice);
            setBuyingMethod("MLM");
            setReferralCodeStatusMsg(`Setting Self Referral Code ${referralCode} for ${bookData.bookTitle}! 😊`);
        
        } else if (referralCode === 'TU2454M5850150') {
            setReferralCodeStatus(true);
            setReferralId("663623dab68a638b3b6a4248");
            setReferralName("Babita Sinha");
            setReferralUserLevel(1);
            setSalesPrice(offerPrice);
            setBuyingMethod("MLM");
            setReferralCodeStatusMsg(`Setting Self Referral Code ${referralCode} for ${bookData.bookTitle}! 😊`);
        } else {
            // console.log("Not In List");
        }
    }, [setReferralCodeStatus]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, setAllowedSelfReferralForBook]);

    const fetchMLMChart = useCallback(() => {
        // console.log("fetchMLMChart for API call ", referralCode, " for bookId ", bookId);
        const config = {
            url: "/mlmchart/advisorasuser",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userCode: referralCode, bookId: bookId }
        };

        fetchData(config)
            .then(response => {
                // console.log("MLM API Response ", response);

                if (response && response.status) {
                    // console.log("MLM record found!!!!!!!!!! ", response);
                    setMLMAdvisor(response.data.mlmAdvisor);
                } else {
                    // console.log("MLM record Not found!???!!!! Response Else ");
                    setMLMAdvisorCheckMsg(`Referral Code ${referralCode} for ${bookData.bookTitle} not found in referral tree! 😔 Make sure the Referral Code is valid.`);
                }
            })
            .catch(error => {
                // console.log("MLM record Not found!???!!!!  Catch Block");
                setMLMAdvisorCheckMsg(`Referral Code ${referralCode} for ${bookData.bookTitle} not found in referral tree! 😔 Make sure the Referral Code is valid.`);
            });
    }, [fetchData, setMLMAdvisor]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchMLMChart]);

    const flashReferralCodeValidationClicked = (referralCode) => {
        const inputValue = referralCode;
        if (/^TU[a-zA-Z0-9]{12}$/.test(referralCode)) {
            // console.log("Valid referralCode", referralCode);
            // fetchReferralCode(referralCode);
            fetchFlashReferralCodeForBook(referralCode);
        } else {
            setError('Please enter a valid 14-character Think5Whys user Code starting with TU');
        }
    };

    const handleFlashReferralCodeValidation = () => {
        setVerifyFlashReferralCodeButtonClicked(true);
    };

    const fetchFlashReferralCodeForBook = useCallback((referralCode) => {
        // console.log("referralCode for API call ", referralCode);
        const config = {
            url: "/auth/verifyreferralcode",
            method: "post",
            headers: { Authorization: authState.token },
            data: { think5whyscode: referralCode }
        };

        fetchData(config)
            .then(response => {
                if (response && response.status) {
                    // console.log("referralCode for flash found ", response);
                    setFlashReferralCodeStatus(true);
                    setFlashReferralId(response.t5wcode._id);
                    setFlashReferralName(response.t5wcode.name);
                    setSalesPrice(splPrice);
                    setBuyingMethod("FLH");
                    setFlashReferralCodeStatusMsg(`Referral Code ${referralCode} found. 😊`);
                } else {
                    // console.log("referralCode Not found");
                    setFlashReferralCodeStatus(false);
                    setFlashReferralCodeStatusMsg(`Referral Code ${referralCode} not found! 😔 Make sure the Referral Code is valid.`);
                }
            })
            .catch(error => {
                // console.log("referralCode for Flash Not found!");
                setFlashReferralCodeStatus(false);
                setFlashReferralCodeStatusMsg(`Referral Code ${referralCode} not found! 😔 Make sure the Referral Code is valid.`);
            });
    }, [fetchData, setFlashReferralCodeStatus]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchFlashReferralCodeForBook]);


    const readfluencerCodeValidationClicked = (readfluencerCode) => {
        const inputValue = readfluencerCode;
        if (/^TU[a-zA-Z0-9]{12}$/.test(readfluencerCode)) {
            // console.log("Valid readfluencerCode", readfluencerCode);
            // fetchReferralCode(readfluencerCode);
            fetchReadfluencerCodeForBook(readfluencerCode);
        } else {
            setError('Please enter a valid 14-character Think5Whys user Code starting with TU');
        }
    };

    const handleReadfluencerCodeValidation = () => {
        setVerifyReadfluencerCodeButtonClicked(true);
    };

    const fetchReadfluencerCodeForBook = useCallback((referralCode) => {
        // console.log("referralCode for API call ", referralCode);
        const config = {
            url: "/auth/verifyreferralcode",
            method: "post",
            headers: { Authorization: authState.token },
            data: { think5whyscode: referralCode }
        };

        fetchData(config)
            .then(response => {
                if (response && response.status) {
                    // console.log("referralCode for flash found ", response);
                    setReadfluencerCodeStatus(true);
                    setReadfluencerId(response.t5wcode._id);
                    setReadfluencerName(response.t5wcode.name);
                    setSalesPrice(splPrice);
                    setBuyingMethod("RFL");
                    setReadfluencerCodeStatusMsg(`Readfluencer Code ${referralCode} found. 😊`);
                } else {
                    // console.log("referralCode Not found");
                    setFlashReferralCodeStatus(false);
                    setFlashReferralCodeStatusMsg(`Referral Code ${referralCode} not found! 😔 Make sure the Readfluencer Code is valid.`);
                }
            })
            .catch(error => {
                // console.log("referralCode for Flash Not found!");
                setReadfluencerCodeStatus(false);
                setReadfluencerCodeStatusMsg(`Readfluencer Code ${referralCode} not found! 😔 Make sure the Readfluencer Code is valid.`);
            });
    }, [fetchData, setReadfluencerCodeStatus]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchReadfluencerCodeForBook]);


    //WalletBalance
    const fetchWalletBalance = useCallback(() => {
        const config = {
            url: "/walletbalance",
            method: "get",
            headers: { Authorization: authState.token }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Wallet Balance Response:", response);
                if (response) {
                    // console.log("Wallet Balance Response in array:", response);
                    setWalletBalanceAmount(response.balanceAmount);
                    setWalletBalancePoints(response.balancePoints);
                    setWalletLastUpdated(response.lastTransactionDate);
                    setWalletLastUpdatedRemarks(response.remarks);
                } else {
                    console.error("Invalid response format: Wallet not found in response");
                    setWalletBalanceAmount(0);
                    setWalletBalancePoints(0);
                    setWalletLastUpdated(null);
                    setWalletLastUpdatedRemarks('');
                }
            })
            .catch(error => {
                console.error("Error fetching wallet master:", error);
                setWalletBalanceAmount(0);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchWalletBalance();
    }, [authState.isLoggedIn, fetchWalletBalance]);


    const handleGiftIt = () => {
        const couponCode = generateGiftCouponCode();
        setGiftCouponCode(couponCode);
        setGiftItClicked(true);
        setIsGifted(1);
    };

    const toggleHighlight = (bookId) => {
        setHighlightStates((prevState) => ({
            ...prevState,
            [bookId]: !prevState[bookId]
        }));
    };

    const toggleBookDesc = (bookId) => {
        setBookDescStates((prevState) => ({
            ...prevState,
            [bookId]: !prevState[bookId]
        }));
    };

    const validateCorpCode = (code) => {
        if (code === '') {
            setError('Corporate ID cannot be blank');
        } else if (!/^\d{8}$/.test(code)) {
            setError('Corporate ID must be exactly 8 digits');
        } else if (!/^1/.test(code)) {
            setError('Corporate ID must start with the digit 1');
        } else {
            setError('');
        }
    };

    const handleCorpCodeChange = (e) => {
        const value = e.target.value;
        setCorpCode(value);
        validateCorpCode(value);
    };

    const validateBookClubCode = (code) => {
        if (code === '') {
            setError('Book Club ID cannot be blank');
        } else if (!/^\d{8}$/.test(code)) {
            setError('Book Club ID must be exactly 8 digits');
        } else if (!/^9/.test(code)) {
            setError('Book Club ID must start with the digit 9');
        } else {
            setError('');
        }
    };

    const handleBookClubCodeChange = (e) => {
        const value = e.target.value;
        setCorpCode(value);
        validateBookClubCode(value);
    };

    return (
        <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans [&_p]:text-white">
            <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
                <div className="flex flex-col">
                    <div className="text-lg lg:text-xl font-bold text-yellow-200">Book Details</div>
                </div>
        
                <div className="hidden md:flex items-center gap-3">
                    {isLoggedIn ? (
                    <>
                        <div className="text-xs text-teal-300">{userName}</div>
                        <button
                        onClick={handleLogout}
                        className="mt-4 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                        title="Logout"
                        >
                        ⏻
                        </button>
                    </>
                    ) : (
                    <>
                        <button
                        onClick={() => navigate("/login")}
                        className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
                        >
                        Login
                        </button>
                    </>
                    )}
                </div>
                <button
                    onClick={() => setIsMobileMenuOpen((s) => !s)}
                    className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
                    aria-label="Toggle menu"
                >
                    {isMobileMenuOpen ? "×" : "☰"}
                </button>
            </header>
    
            {/* Mobile menu content */}
            {isMobileMenuOpen && (
            <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
                {isLoggedIn ? (
                <div className="flex flex-col items-center gap-3">
                    <div className="text-teal-300 text-xs font-medium">{userName}</div>
                    <div className="flex gap-3">
                    <button
                        onClick={handleLogout}
                        className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                    >
                        ⏻
                    </button>
                    </div>
                </div>
                ) : (
                <div className="flex justify-center gap-6">
                    <Link to="/login" className="text-teal-300">Login</Link>
                </div>
                )}
            </div>
            )}
            <div className="mt-2">
                <div className="flex flex-col items-center justify-center mt-2">
                    <div className="book-info ">
                        <div className="thumb-book-image-container">
                            <img 
                                src={`/api/bookworldthumb/${bookData.bookImage}.png`}
                                alt={"No Image " + bookData.bookTitle} 
                                className="thumb-book-image"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col justify-center items-center mt-2 mb-4">
                        <h2 className='text-yellow-200 text-sm lg:text-lg'>{bookData.bookTitle}</h2>
                        <p className="book-author text-blue-500">by {bookData.bookAuthor}</p>
                        <p className="book-author text-blue-500"><del className='text-red-500'>Price ₹{bookData.coverPrice.toFixed(2)}</del><strong className='text-green-500'> Buy Now @ ₹{bookData.offerPrice.toFixed(2)}</strong></p>
                        {bookData.isPriceInDollarEnabled && (
                            <div className='bg-yellow-200'>
                                <div className='mt-4'>
                                    <p className="book-author text-white"><del className='text-red-500'>Price ${(bookData.coverPrice*dollarPriceMultiply).toFixed(2)}</del><strong className='text-green-500'> Buy Now @ ${(bookData.offerPrice*dollarPriceMultiply).toFixed(2)}</strong></p>
                                </div>
                                <div className='mb-4'>
                                    <p className="text-purple-700 px-2">Note: If you purchase this from outside India your price will be in US$ converted into INR (₹) by multiplying {bookData.inrToDollarConversionRate} for every pricing calculation thereon on the platform.</p>
                                </div>
                            </div>
                        )}
                        <p className="text-sm lg:text-sm text-white">Free Page Reading {bookData.freeReads} Times<strong className='text-orange-500'> Paid Pages Readings {bookData.paidReads} Times</strong></p>
                    </div>
                    <div className="details-container mt-4 mb-2">
                        <Tooltip text={bookData.hasPracticeTest === 1 ? "This has Practice Test" : "This has no Practice Test"} position={"top"}>
                            <span className={`text-${bookData.hasPracticeTest === 1 ? 'green' : 'blue'}-500 mr-4`}>
                                {bookData.hasPracticeTest === 1 ? (
                                    <FontAwesomeIcon icon={faCheck} className="text-2xl" />
                                ) : (
                                    <FontAwesomeIcon icon={faCheck} className="text-blue-500 text-2xl" />
                                )}
                            </span>
                        </Tooltip>
                        <Tooltip text={bookData.hasAssignment === 1 ? "This has Assignment" : "This has no Assignment"} position={"top"}>
                            <span className={`text-${bookData.hasAssignment === 1 ? 'green' : 'blue'}-500 mr-4`}>
                                {bookData.hasAssignment === 1 ? (
                                    <FontAwesomeIcon icon={faFileAlt} className="text-lg lg:text-xl" />
                                ) : (
                                    <FontAwesomeIcon icon={faFileAlt} className="text-blue-500 text-lg lg:text-xl" />
                                )}
                            </span>
                        </Tooltip>
                        <Tooltip text={bookData.hasExam === 1 ? "This has Exam" : "This has no Exam"} position={"top"}>
                            <span className={`text-${bookData.hasExam === 1 ? 'green' : 'blue'}-500 mr-4`}>
                                {bookData.hasExam === 1 ? (
                                    <FontAwesomeIcon icon={faClipboardCheck} className="text-2xl" />
                                ) : (
                                    <FontAwesomeIcon icon={faClipboardCheck} className="text-blue-500 text-2xl" />
                                )}
                            </span>
                        </Tooltip>
                        <Tooltip text={bookData.hasCertificate === 1 ? "This has Certificate" : "This has no Certificate"} position={"top"}>
                            <span className={`text-${bookData.hasCertificate === 1 ? 'green' : 'blue'}-500 mr-4`}>
                                {bookData.hasCertificate === 1 ? (
                                    <FontAwesomeIcon icon={faCertificate} className="text-2xl" />
                                ) : (
                                    <FontAwesomeIcon icon={faCertificate} className="text-blue-500 text-2xl" />
                                )}
                            </span>
                        </Tooltip>
                    </div>
                    <div className="details-container">
                        <h2 className={`${bookData.isAvailable === 1 ? 'text-green-500' : 'text-yellow-300'} text-sm lg:text-lg mt-2`}>
                            {bookData.isAvailable === 1 ? "Available" : "Currently Unavailable"}
                        </h2>
                    </div>
                    {bookData.bookHighlight !== "" && (
                        <>
                            <div className="details-container">
                                <button
                                    onClick={() => toggleHighlight(bookData._id)}
                                    style={{ maxWidth: '150px' }}
                                    className="show-button"
                                >
                                    {highlightStates[bookData._id] ? 'Hide Highlights' : 'Show Highlights'}
                                </button>
                            </div>
                            {highlightStates[bookData._id] && (
                                <div className="highlight-container" style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: bookData.bookHighlight }} />
                            )}
                        </>
                    )}
                    {bookData.bookDesc !== "" && (
                        <>
                            <div className="details-container mt-2">
                                <button
                                    onClick={() => toggleBookDesc(bookData._id)}
                                    style={{ maxWidth: '250px' }}
                                    className="show-button"
                                >
                                    {bookDescStates[bookData._id] ? 'Hide Details' : 'Show Details'}
                                </button>
                            </div>
                            {bookDescStates[bookData._id] && (
                                <div className="details-container mt-1 mb-2">
                                    {/* <p className="text-white text-sm lg:lg mt-1">Book Description:</p> */}
                                    <div className="highlight-container" style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: bookData.bookDesc }} />
                                </div>
                            )}
                        </>
                    )}
                    {bookData.isAvailable === 1 && (
                        <>
                            <div className="details-container mt-2">
                                <h2 className='text-lime-500 text-lg mb-4'><FontAwesomeIcon icon={faBookAtlas} className="text-blue-500 text-4xl" /></h2>
                            </div>
                            <div className="details-container mt-2">
                                {hasPurchased && (
                                    <h2 className='bg-purple-800 text-white text-xl'><strong>This is already in your own Bookshelf! Gift It to somebody!!</strong></h2>
                                )}
                            </div>
                            <div className="details-container mt-2">
                                {!hasPurchased && (
                                    <h2 className='text-white text-sm lg:text-lg'><strong>Bring this into your Think5Whys Bookshelf!</strong></h2>
                                )}
                            </div>
                            {isFree === 1 && (
                                <button onClick={handleAddFreeClicked} className="think5whys-button" disabled={hasPurchased}>Add Free To BookShelf</button>
                            )}
                            <button onClick={handleBuyBook} className="text-sm bg-purple-600 text-white w-40 lg:w-80 mb-2 rounded-md" disabled={hasPurchased || isFree === 1}> Direct Purchase </button>
                            {buyingClicked && (
                                <div className="details-container w-full mx-auto text-white bg-black border border-gray-400 rounded-lg shadow-lg p-4 mb-2">
                                    <div className="mb-2">
                                        <div className="mb-4 text-lg text-white">
                                            <p>Price to pay: <span className='text-yellow-300'>₹{paymentAmount.toFixed(2)}</span></p>
                                            <p>Think5Whys Purse / Wallet Balance: <span className='text-yellow-300'>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                            {paymentAmount > walletBalanceAmount ? (
                                                <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                            ) : (
                                                <p className="text-white">
                                                    After payment your Think5Whys Purse / Wallet balance will be: <span className='text-yellow-300'>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    {walletBalanceAmount < bookData.offerPrice && (
                                        <div className='mb-4 flex text-wrap justify-center'>
                                            <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>
                                        </div>
                                    )}
                                    {walletBalanceAmount >= bookData.offerPrice && (
                                        <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-black text-white mx-auto my-4">
                                            <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                                            <div className="space-y-2 text-gray-700">
                                                <p><strong>Order Number:</strong> {orderNumber}</p>
                                                <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                <p><strong>Customer Name:</strong> {customerName}</p>
                                                <p><strong>Customer Address:</strong> Online Digital Product</p>
                                                <p><strong>Item:</strong> {bookData.bookTitle}</p>
                                                <p><strong>Item Description:</strong> {bookData.bookTitle}</p>
                                                <p className="text-lg font-bold text-green-600"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                                <p className="text-lg font-bold text-green-600"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                                <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                            </div>
                                            <div className="flex justify-center mt-6">
                                            <button
                                                type="button"
                                                className="bg-green-800 text-white text-xs lg:text-sm w-full py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                                // onClick={walletPaymentClicked}
                                                onClick={() => walletPaymentClicked(orderNumber, purchaseDate, customerName, bookData.bookTitle, paymentAmount)}

                                            >
                                                Confirm Now To Buy. Your Think5Whys Purse / Wallet Will Be Dedcuted.
                                            </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            {bookData.isMLM && (
                                <>
                                <div className='bg-black border border-gray-300 text-white py-4 px-4 flex flex-col justify-center items-center'>
                                    <p className='text-yellow-200 text-sm lg:text-lg text-center'>Use Referral Code and Enroll Yourself Under Think5Whys Network Referral Program</p>
                                    <p className='text-white text-sm lg:text-lg text-center py-2'>Ask Referral Code from the Referrer. The code could be found under Home{'->'}Profile{'->'}My Think5Whys Code</p>
                                    <p className='text-white text-sm lg:text-lg text-center py-2'>If you are referring then get your Referral Code from Home{'->'}Profile{'->'}My Think5Whys Code</p>
                                    <button
                                        type="button"
                                        className="bg-orange-500 text-white py-2 px-4 text-sm w-64 lg:w-80 rounded-md font-medium hover:bg-primary-dark"
                                        onClick={handleReferralCodeClick}
                                        disabled={buyingClicked || hasDiscountCouponClicked || hasFlashReferralCodeClicked || hasRedeemGiftClicked || hasCorpPassClicked || hasBookClubTokenClicked || hasPurchased || isFree === 1}
                                    >
                                        Buy Using Network Referral Code
                                    </button>
                                    {hasReferralCodeClicked && (
                                        <div className="flex flex-col justify-center items-center w-full mx-auto text-white bg-black rounded-lg shadow-lg mb-2 mt-2">
                                            <div className='mt-4 flex text-wrap justify-center'>
                                                <p className='text-yellow-400 text-center'>Input 14 Characters Alphanumeric Referrer ID (eg TU243AM5850150):</p>
                                            </div>
                                            <div className='mb-4 flex text-wrap justify-center'>
                                                <p className='text-white text-center'>Ask your referrer to provide their Referrer Code from Home {'->'} Profile {'->'} My Think5Whys Code</p>
                                            </div>
                                            <div className='mb-4 flex text-wrap justify-center'>
                                                <p className='text-white'>Your User Code is {userCode}</p>
                                            </div>
                                            <div className='mb-4 flex text-wrap justify-center'>
                                                <p className='text-yellow-400 text-center'>To apply their Referrer Code they must have purchase this item using "Buy Using Network Referral Code"</p>
                                            </div>
                                            <div className="mb-4 flex justify-center">
                                                <input
                                                    type="text"
                                                    name="referralCode"
                                                    id="referralCode"
                                                    value={referralCode}
                                                    placeholder="Input Referrer ID"
                                                    onChange={(e) => setReferralCode(e.target.value)}
                                                    style={{width: "250px"}}
                                                    className="h-10 w-full text-black text-center p-1 border border-gray-300"
                                                />
                                            </div>
                                            <div className="mb-4 flex justify-center">
                                                {error && <p className="text-red-800 justify-left text-sm lg:text-lg text-center">{error}</p>}
                                            </div>
                                            <div className='mb-4 flex flex-col items-center'>
                                                <p className={referralCodeStatus ? "text-green-800 text-sm lg:text-lg text-center" : "text-red-600 text-lg"}>
                                                    {referralCodeStatusMsg}
                                                </p>
                                                <button
                                                    type="button"
                                                    className="block w-48 lg:w-64 text-xs lg:text-sm bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                    onClick={() => {
                                                        referralCodeValidationClicked(referralCode, bookId);
                                                        handleReferralCodeValidation();
                                                    }}
                                                    disabled={referralCodeStatus}
                                                >
                                                    {referralCodeStatus ? "Referrer ID Validated" : "Validate Referrer ID"}
                                                </button>
                                                {referralCodeStatus && (
                                                    <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-2">
                                                        {referralCode && (
                                                            <div className="flex justify-center">
                                                                <p className="text-white text-lg">Your Referrer Name: <strong className="text-yellow-300 text-lg">{referralName}</strong></p>
                                                            </div>
                                                        )}
                                                        <div className="mt-6 mb-2">
                                                            <div className="mb-4 text-lg text-white">
                                                                <p>Price to pay: <span className='text-yellow-300'>₹{paymentAmount.toFixed(2)}</span></p>
                                                                <p>Think5Whys Purse / Wallet Balance: <span className='text-yellow-300'>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                                                {paymentAmount > walletBalanceAmount ? (
                                                                    <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                                                ) : (
                                                                    <p className="text-white">
                                                                        After payment your Think5Whys Purse / Wallet balance will be: <span className='text-yellow-300'>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {walletBalanceAmount < bookData.offerPrice && (
                                                            <div className='mb-4 flex text-wrap justify-center'>
                                                                <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>
                                                            </div>
                                                        )}
                                                        {walletBalanceAmount >= bookData.offerPrice && (
                                                            <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-black text-white mx-auto my-4">
                                                                <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                                                                <div className="space-y-2 text-gray-700">
                                                                <p><strong>Order Number:</strong> {orderNumber}</p>
                                                                <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                                <p><strong>Customer Name:</strong> {customerName}</p>
                                                                <p><strong>Customer Address:</strong> Online Digital Product</p>
                                                                <p><strong>Item:</strong> {bookData.bookTitle}</p>
                                                                <p><strong>Item Description:</strong> {bookData.bookTitle}</p>
                                                                <p className="text-lg font-bold text-green-600"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                                                <p className="text-lg font-bold text-green-600"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                                                <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                                </div>
                                                                <div className="flex justify-center mt-6">
                                                                <button
                                                                    type="button"
                                                                    className="bg-green-800 text-white text-xs lg:text-sm w-full py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                                                    // onClick={walletPaymentClicked}
                                                                    onClick={() => walletPaymentClicked(orderNumber, purchaseDate, customerName, bookData.bookTitle, paymentAmount)}

                                                                >
                                                                    Confirm Now To Buy. Your Think5Whys Purse / Wallet Will Be Dedcuted.
                                                                </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>       
                                
                                </>
                            )}
                            {bookData.hasDiscountedPrice === 1 && (
                                <>
                                    <p className='text-yellow-200 text-xs lg:text-sm mt-2 text-center'>
                                        This title is available on discount through Think5Whys DigiLearn Ambassadors
                                    </p>
                                    <p className='text-sm text-center'>
                                        <strong className='text-white mt-2'> 
                                            Price on Discount Coupon @ ₹{bookData.discountedPrice.toFixed(2)}
                                            {bookData.isPriceInDollarEnabled && ( <span className='text-orange-500'> (${(bookData.discountedPrice*dollarPriceMultiply).toFixed(2)})</span>)}
                                        </strong>
                                    </p>
                                    <p className='text-yellow-200 text-center text-xs lg:text-sm'>Contact Think5Whys DigiLearn Ambassadors To Get Discount Coupon</p>
                                    <button
                                        type="button"
                                        className="bg-yellow-500 text-white text-xs lg:text-sm w-64 lg:w-80 py-2 px-4 mt-1 mb-1 rounded-md font-medium hover:bg-primary-dark"
                                        onClick={handleDiscountCouponClick}
                                        disabled={buyingClicked || hasReferralCodeClicked || hasFlashReferralCodeClicked || hasReadfluencerCodeClicked || hasRedeemGiftClicked || hasCorpPassClicked || hasBookClubTokenClicked || hasPurchased || isFree === 1}
                                    >
                                        I have A Franchise Discount Coupon
                                    </button>
                                    {hasDiscountCouponClicked && (
                                        <div className="details-container w-full mx-auto text-black bg-slate-400 rounded-lg shadow-lg mb-4">
                                            <div className='mb-4 text-lg text-white'>
                                                <p className=''>Price to pay: <span className='text-yellow-300'>₹{offerPrice.toFixed(2)}</span></p>
                                                <p>If you have a Think5Whys Discount Coupon then You will have to pay <span className='text-yellow-300'>₹{bookData.discountedPrice.toFixed(2)}</span></p>
                                            </div>
                                            <div className='mb-4 flex text-wrap justify-center'>
                                                <p className='text-white'>Input Your 12 Characters Alphanumeric Discount Coupon Code:</p>
                                            </div>
                                            <div className="mb-4 flex justify-center">
                                                <input
                                                    type="text"
                                                    name="discountCouponCode"
                                                    id="discountCouponCode"
                                                    value={discountCouponCode}
                                                    placeholder="Input Coupon Code"
                                                    onChange={(e) => setDiscountCouponCode(e.target.value)}
                                                    className="h-12 text-center p-2 border border-gray-300"
                                                />
                                            </div>
                                            <div className="mb-4 flex justify-center">
                                                {error && <p className="text-red-800 justify-left">{error}</p>}
                                            </div>
                                            <div className='mb-4 flex flex-col items-center'>
                                                {discountCouponStatus ? (
                                                    <p className={discountCouponIsRedeemed === 0 ? "text-green-800 text-lg" : "text-blue-800 text-lg"}>
                                                        {discountCouponStatusMsg}
                                                    </p>
                                                ) : (
                                                    <p className="text-red-800 text-lg">
                                                        {discountCouponStatusMsg}
                                                    </p>
                                                    
                                                )}
                                                <button
                                                    type="button"
                                                    className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                    onClick={() => {
                                                        discountCouponValidationClicked(discountCouponCode);
                                                        handleDiscountCouponValidation();
                                                    }}
                                                    disabled={discountCouponStatus}
                                                >
                                                    {discountCouponStatus ? "Validated" : "Validate Discount Coupon"}
                                                </button>
                                                { (discountCouponStatus === true && discountCouponIsRedeemed === 0) && (
                                                    <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-2">
                                                        <div className="mb-2">
                                                            <div className="mb-4 text-lg text-white">
                                                                <p>Price to pay: <span className='text-yellow-300'>₹{paymentAmount.toFixed(2)}</span></p>
                                                                <p>Think5Whys Purse / Wallet Balance: <span className='text-yellow-300'>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                                                {paymentAmount > walletBalanceAmount ? (
                                                                    <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                                                ) : (
                                                                    <p className="text-white">
                                                                        After payment your Think5Whys Purse / Wallet balance will be: <span className='text-yellow-300'>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {walletBalanceAmount < bookData.offerPrice && (
                                                            <div className='mb-4 flex text-wrap justify-center'>
                                                                <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>
                                                            </div>
                                                        )}
                                                        {walletBalanceAmount >= bookData.offerPrice && (
                                                            <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-black text-white mx-auto my-4">
                                                                <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                                                                <div className="space-y-2 text-gray-700">
                                                                <p><strong>Order Number:</strong> {orderNumber}</p>
                                                                <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                                <p><strong>Customer Name:</strong> {customerName}</p>
                                                                <p><strong>Customer Address:</strong> Online Digital Product</p>
                                                                <p><strong>Item:</strong> {bookData.bookTitle}</p>
                                                                <p><strong>Item Description:</strong> {bookData.bookTitle}</p>
                                                                <p className="text-lg font-bold text-green-600"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                                                <p className="text-lg font-bold text-green-600"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                                                <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                                </div>
                                                                <div className="flex justify-center mt-6">
                                                                <button
                                                                    type="button"
                                                                    className="bg-green-800 text-white text-xs lg:text-sm w-full py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                                                    // onClick={walletPaymentClicked}
                                                                    onClick={() => walletPaymentClicked(orderNumber, purchaseDate, customerName, bookData.bookTitle, paymentAmount)}

                                                                >
                                                                    Confirm Now To Buy. Your Think5Whys Purse / Wallet Will Be Dedcuted
                                                                </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            {discountCouponIsApplied === 1 && (
                                                <p className="text-red-600 mb-4">Discount Coupon has already been used! Make sure that you are applying an unused discount coupon.</p>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                            {bookData.isFlashReferralEnabled && (
                                <>
                                <div>
                                    <div className='bg-black kborder border-gray-300 text-white py-4 px-4 flex flex-col items-center justify-center'>
                                        <p className='text-yellow-200 tx-lg mt-4 text-center'>BoostBuddies: This title is available on discount through Think5Whys User Code</p>
                                        <p>
                                            <strong className='textwhite mt-2'> 
                                                Special Price @ ₹{splPrice.toFixed(2)}
                                            </strong>
                                            {bookData.isPriceInDollarEnabled && (
                                                <strong className='text-yellow-200 mt-2 ml-2'> 
                                                    (${(splPrice*dollarPriceMultiply).toFixed(2)})
                                                </strong>
                                            )}
                                        </p>

                                        <p className='text-white text-sm lg:text-sm items-center py-2'>In BoostBuddies, any Think5Whys user can Provide their Think5Whys User Code</p>
                                        <button
                                            type="button"
                                            className="bg-blue-500 text-xs lg:text-sm w-64 lg:w-80 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                            onClick={handleFlashReferralCodeClick}
                                            disabled={buyingClicked || hasDiscountCouponClicked || hasReferralCodeClicked  || hasReadfluencerCodeClicked || hasRedeemGiftClicked || hasCorpPassClicked || hasBookClubTokenClicked || hasPurchased || isFree === 1}
                                        >
                                            I have my BoostBuddies Code
                                        </button>
                                    </div>
                                    {hasFlashReferralCodeClicked && (
                                        <div className="details-container w-full mx-auto text-black bg-slate-400 rounded-lg shadow-lg mb-4">
                                            <div className='mb-4 text-lg text-white'>
                                                <p className=''>Price to pay: <span className='text-yellow-300'>₹{offerPrice.toFixed(2)}</span></p>
                                                <p className='ml-4 mr-4'>If you have a Think5Whys BoostBuddies User Code then You will have to pay <span className='text-yellow-300'>₹{splPrice.toFixed(2)}</span></p>
                                            </div>
                                            <div className='mb-4 flex text-wrap justify-center'>
                                                <p className='text-white'>Input a 14 Characters Alphanumeric Think5Whys BoostBuddies User Code:</p>
                                            </div>
                                            <div className="mb-4 flex justify-center">
                                                <input
                                                    type="text"
                                                    name="referralCode"
                                                    id="referralCode"
                                                    value={referralCode}
                                                    placeholder="Input Referrer ID"
                                                    onChange={(e) => setReferralCode(e.target.value)}
                                                    className="h-12 text-center p-2 border border-gray-300"
                                                />
                                            </div>
                                            <div className="mb-4 flex justify-center">
                                                {error && <p className="text-red-800 justify-left">{error}</p>}
                                            </div>
                                            <div className='mb-4 flex flex-col items-center'>
                                                <p className={flashReferralCodeStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                                                    {flashReferralCodeStatusMsg}
                                                </p>
                                                {flashReferralCodeStatus && <p className='text-blue-800 text-xl'>The BoostBuddies Referrer Name is {flashReferralName}</p>}
                                                <button
                                                    type="button"
                                                    className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                    onClick={() => {
                                                        flashReferralCodeValidationClicked(referralCode);
                                                        handleFlashReferralCodeValidation();
                                                    }}
                                                    disabled={flashReferralCodeStatus}
                                                >
                                                    {flashReferralCodeStatus ? "Referrer ID Validated" : "Validate Referrer ID"}
                                                </button>
                                                {flashReferralCodeStatus && (
                                                    <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-2">
                                                        <div className="mb-2">
                                                            <div className="mb-4 text-lg text-white">
                                                                <p>Price to pay: <span className='text-yellow-300'>₹{splPrice.toFixed(2)}</span></p>
                                                                <p>Think5Whys Purse / Wallet Balance: <span className='text-yellow-300'>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                                                {paymentAmount > walletBalanceAmount ? (
                                                                    <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                                                ) : (
                                                                    <p className="text-white">
                                                                        After payment your Think5Whys Purse / Wallet balance will be: <span className='text-yellow-300'>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {walletBalanceAmount < bookData.offerPrice && (
                                                            <div className='mb-4 flex text-wrap justify-center'>
                                                                <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>
                                                            </div>
                                                        )}
                                                        {walletBalanceAmount >= bookData.offerPrice && (
                                                            <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-black text-white mx-auto my-4">
                                                                <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                                                                <div className="space-y-2 text-gray-700">
                                                                <p><strong>Order Number:</strong> {orderNumber}</p>
                                                                <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                                <p><strong>Customer Name:</strong> {customerName}</p>
                                                                <p><strong>Customer Address:</strong> Online Digital Product</p>
                                                                <p><strong>Item:</strong> {bookData.bookTitle}</p>
                                                                <p><strong>Item Description:</strong> {bookData.bookTitle}</p>
                                                                <p className="text-lg font-bold text-green-600"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                                                <p className="text-lg font-bold text-green-600"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                                                <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                                </div>
                                                                <div className="flex justify-center mt-6">
                                                                <button
                                                                    type="button"
                                                                    className="bg-green-800 text-white text-xs lg:text-sm w-full py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                                                    // onClick={walletPaymentClicked}
                                                                    onClick={() => walletPaymentClicked(orderNumber, purchaseDate, customerName, bookData.bookTitle, paymentAmount)}

                                                                >
                                                                    Confirm Now To Buy. Your Think5Whys Purse / Wallet Will Be Dedcuted
                                                                </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                </>
                            )}
                            {bookData.isReadfluencerEnabled && (
                                <>
                                <div className='mt-4'>
                                    <div className='bg-blue-300 text-white py-4 px-4'>
                                        <p className='text-yellow-200 tx-lg mt-4'>Readfluencer: This title is available through Think5Whys Mentor or Influencer Code</p>
                                        {/* <p>
                                            <strong className='text-blue-500 mt-2'> 
                                                Special Price @ ₹{splPrice.toFixed(2)}
                                            </strong>
                                            {bookData.isPriceInDollarEnabled && (
                                                <strong className='text-orange-500 mt-2 ml-2'> 
                                                    (${(splPrice*dollarPriceMultiply).toFixed(2)})
                                                </strong>
                                            )}
                                        </p> */}

                                        <p className='text-black'>A Readfluencer must be a Think5Whys User</p>
                                        <button
                                            type="button"
                                            className="bg-blue-500 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                            onClick={handleReadfluencerCodeClick}
                                            disabled={buyingClicked || hasDiscountCouponClicked || hasReferralCodeClicked || hasFlashReferralCodeClicked || hasRedeemGiftClicked || hasCorpPassClicked || hasBookClubTokenClicked || hasPurchased || isFree === 1}
                                        >
                                            I have my Readfluence Code
                                        </button>
                                    </div>
                                    { hasReadfluencerCodeClicked && (
                                        <div className="details-container w-full mx-auto text-black bg-slate-400 rounded-lg shadow-lg mb-4">
                                            <div className='mb-4 flex text-wrap justify-center'>
                                                <p className='text-white'>Input a 14 Characters Alphanumeric Think5Whys Readfluencer User Code:</p>
                                            </div>
                                            <div className="mb-4 flex justify-center">
                                                <input
                                                    type="text"
                                                    name="readfluencerCode"
                                                    id="readfluencerCode"
                                                    value={readfluencerCode}
                                                    placeholder="Input Referrer ID"
                                                    onChange={(e) => setReadfluencerCode(e.target.value)}
                                                    className="h-12 text-center p-2 border border-gray-300"
                                                />
                                            </div>
                                            <div className="mb-4 flex justify-center">
                                                {error && <p className="text-red-800 justify-left">{error}</p>}
                                            </div>
                                            <div className='mb-4 flex flex-col items-center'>
                                                <p className={readfluencerCodeStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                                                    {readfluencerCodeStatusMsg}
                                                </p>
                                                {readfluencerCodeStatus && <p className='text-blue-800 text-xl'>The Readfluencer Name is {readfluencerName}</p>}
                                                <button
                                                    type="button"
                                                    className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                    onClick={() => {
                                                        readfluencerCodeValidationClicked(readfluencerCode);
                                                        handleReadfluencerCodeValidation();
                                                    }}
                                                    disabled={readfluencerCodeStatus}
                                                >
                                                    {readfluencerCodeStatus ? "Readfluencer ID Validated" : "Validate Readfluencer ID"}
                                                </button>
                                                {readfluencerCodeStatus && (
                                                    <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-2">
                                                        <div className="mb-2">
                                                            <div className="mb-4 text-lg text-white">
                                                                <p>Price to pay: <span className='text-yellow-300'>₹{splPrice.toFixed(2)}</span></p>
                                                                <p>Think5Whys Purse / Wallet Balance: <span className='text-yellow-300'>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                                                {paymentAmount > walletBalanceAmount ? (
                                                                    <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                                                ) : (
                                                                    <p className="text-white">
                                                                        After payment your Think5Whys Purse / Wallet balance will be: <span className='text-yellow-300'>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {walletBalanceAmount < bookData.offerPrice && (
                                                            <div className='mb-4 flex text-wrap justify-center'>
                                                                <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>
                                                            </div>
                                                        )}
                                                        {walletBalanceAmount >= bookData.offerPrice && (
                                                            <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-black text-white mx-auto my-4">
                                                                <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                                                                <div className="space-y-2 text-gray-700">
                                                                <p><strong>Order Number:</strong> {orderNumber}</p>
                                                                <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                                <p><strong>Customer Name:</strong> {customerName}</p>
                                                                <p><strong>Customer Address:</strong> Online Digital Product</p>
                                                                <p><strong>Item:</strong> {bookData.bookTitle}</p>
                                                                <p><strong>Item Description:</strong> {bookData.bookTitle}</p>
                                                                <p className="text-lg font-bold text-green-600"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                                                <p className="text-lg font-bold text-green-600"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                                                <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                                </div>
                                                                <div className="flex justify-center mt-6">
                                                                <button
                                                                    type="button"
                                                                    className="bg-green-800 text-white text-xs lg:text-sm w-full py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                                                    // onClick={walletPaymentClicked}
                                                                    onClick={() => walletPaymentClicked(orderNumber, purchaseDate, customerName, bookData.bookTitle, paymentAmount)}

                                                                >
                                                                    Confirm Now To Buy. Your Think5Whys Purse / Wallet Will Be Dedcuted
                                                                </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                </>
                            )}
                            <p className='text-orange-200 mt-2 mb-2 text-center'>Someone Have Gifted This To You?! Redeem Your Gift Coupon</p>
                            <button
                                type="button"
                                className="bg-purple-800 text-white w-48 lg:w-80 text-xs lg:text-sm py-2 px-4 mb-2 rounded-md font-medium hover:bg-primary-dark"
                                onClick={handleRedeemGiftClick}
                                disabled={buyingClicked || hasDiscountCouponClicked || hasReferralCodeClicked || hasFlashReferralCodeClicked || hasReadfluencerCodeClicked || hasCorpPassClicked || hasBookClubTokenClicked || hasPurchased || isFree === 1}
                            >
                                I have A Gift Coupon
                            </button>
                            {hasRedeemGiftClicked && (
                                <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-4">
                                    <div className="mb-4 flex flex-col items-center">
                                        <div className="flex text-wrap justify-center">
                                            <label htmlFor="giftCouponCode" className="block text-lg text-center text-yellow-400">Input Your 13 Characters Alphanumeric Gift Coupon Code</label>
                                        </div>
                                        <div className="mb-2 flex justify-center">
                                            <input
                                                type="text"
                                                name="giftCouponCode"
                                                id="giftCouponCode"
                                                value={giftCouponCode}
                                                placeholder="Input Give Coupon Code"
                                                onChange={(e) => setGiftCouponCode(e.target.value)}
                                                className="h-12 text-center p-2 border border-gray-300 w-120"
                                                style={{ width: '10rem' }}
                                            />
                                        </div>
                                        <div className="mb-4 flex justify-center">
                                            {error && <p className="text-red-600 justify-center">{error}</p>}
                                        </div>
                                    </div>
                                    <div className='mb-4 flex flex-col items-center'>
                                        {myCouponStatus === false && (
                                            <p className={myCouponStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                                                {couponStatusMsg}
                                            </p>
                                        )}
                                        {myCouponStatus && giftCouponIsRedeemed === 0 && (
                                            <p className={myCouponStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                                                {couponStatusMsg}
                                            </p>
                                        )}
                                        {giftCouponIsRedeemed === 1 && (
                                            <p className="text-red-600">Sorry! Gift Coupon {giftCouponCode} has already been redeemed! Please retry with an unused Gift Coupon.</p>
                                        )}
                                        <button
                                            type="button"
                                            className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                            onClick={() => {
                                                giftCouponValidationClicked(giftCouponCode, corpCode, bookId, "GC", "Gift Coupon");
                                                handleGiftCouponValidation();
                                            }}
                                            disabled={myCouponStatus}
                                        >
                                            {myCouponStatus ? "Verified" : "Verify Gift Coupon"}
                                        </button>
                                    </div>
                                    {giftCouponIsRedeemed === 0 && (
                                        <>
                                            {myCouponStatus && (
                                                <div className='mb-4 text-wrap bg-green-700 justify-center'>
                                                    <div className="flex flex-col mb-2">
                                                        <div className="flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faGifts} className="text-red-500 text-4xl mr-2" />
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col mb-2">
                                                        <div className="flex items-center justify-center">
                                                            <p className="text-yellow-300">{entityName}</p>
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col mb-2">
                                                        <div className="flex items-center justify-center">
                                                            <p className="text-white">Gifted By: {gifterName}</p>
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col mb-2">
                                                        <div className="flex items-center justify-center">
                                                            <p className="text-yellow-300">{giftMessage}</p>
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col mb-2">
                                                        <div className="flex items-center justify-center mb-4">
                                                            <p className="text-white">{gifterSignatureLine}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {myCouponStatus && (
                                                <div className="mb-4">
                                                    <div className="flex text-wrap justify-center">
                                                        <label htmlFor="giftThankYouMessage" className="block text-lg text-yellow-400">Write Thank You Message:</label>
                                                    </div>
                                                    <div className="mb-2 flex justify-center">
                                                        <textarea
                                                            type="text"
                                                            name="giftThankYouMessage"
                                                            id="giftThankYouMessage"
                                                            className="block text-m font-medium bg-gray-700 w-full"
                                                            value={giftThankYouMessage}
                                                            placeholder="Happy reading!!"
                                                            onChange={e => setGiftThankYouMessage(e.target.value)}
                                                            style={{ height: '200px' }}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {myCouponStatus && (
                                                <div className='mb-4 flex text-wrap justify-center'>
                                                    <button type="button" className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRedeemNow}>Redeem Now</button>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                            
                            {bookData.isCorpPassEnabled && (
                                <>
                                <div className='bg-gray-300 text-white py-4 px-4'>
                                    <p className='text-black'>Your Company or Office has Provided You a Corporate Pass?! Redeem Your Corporate Pass.</p>
                                    <button
                                        type="button"
                                        className="bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                        onClick={handleRedeemCorpPassClick}
                                        disabled={buyingClicked || hasDiscountCouponClicked || hasReferralCodeClicked || hasFlashReferralCodeClicked || hasRedeemGiftClicked || hasBookClubTokenClicked || hasPurchased || isFree === 1}
                                    >
                                        I have My Corporate Pass Code
                                    </button>
                                </div>
                                {hasCorpPassClicked && (
                                    <div className="details-container w-full mx-auto text-black bg-slate-400 rounded-lg shadow-lg mb-4">
                                        <div className="mb-4">
                                            <div className="flex text-wrap justify-center">
                                                <label htmlFor="giftCouponCode" className="block text-lg text-white">Your 13 Characters Alphanumeric Corporate Pass Code:</label>
                                            </div>
                                            <div className="mb-2 flex justify-center">
                                                <input
                                                    type="text"
                                                    name="giftCouponCode"
                                                    id="giftCouponCode"
                                                    value={giftCouponCode}
                                                    placeholder="Input Pass Code"
                                                    onChange={(e) => setGiftCouponCode(e.target.value)}
                                                    className="h-12 text-center p-2 border border-gray-300"
                                                />
                                            </div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="flex text-wrap justify-center">
                                                <label htmlFor="corpCode" className="block text-lg text-white">Input 8 digit Think5Whys Corporate ID</label>
                                            </div>
                                            <div className="mb-2 flex justify-center">
                                                <input
                                                    type="text"
                                                    name="corpCode"
                                                    id="corpCode"
                                                    value={corpCode}
                                                    placeholder="Enter Corporate ID"
                                                    onChange={handleCorpCodeChange}
                                                    className="h-12 text-center p-2 border border-gray-300"
                                                />
                                            </div>
                                            {error && (
                                                <div className="mb-4 flex justify-center">
                                                    <p className="text-red-600 text-center">{error}</p>
                                                </div>
                                            )}
                                        </div>
                                        <div className='mb-4 flex flex-col items-center'>
                                            {myCouponStatus === false && (
                                                <p className={myCouponStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                                                    {couponStatusMsg}
                                                </p>
                                            )}
                                            {myCouponStatus && giftCouponIsRedeemed === 0 && (
                                                <p className={myCouponStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                                                    {couponStatusMsg}
                                                </p>
                                            )}
                                            {giftCouponIsRedeemed === 1 && (
                                                <p className="text-red-600">Sorry! Coproprate Pass  {giftCouponCode} you have provided has already been used! Please retry with an unused Corporate Pass.</p>
                                            )}
                                            <button
                                                type="button"
                                                className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                onClick={() => {
                                                    giftCouponValidationClicked(giftCouponCode, corpCode, bookId, "CorpGift", "Corporate Pass");
                                                    handleGiftCouponValidation();
                                                }}
                                                disabled={myCouponStatus}
                                            >
                                                {myCouponStatus ? "Verified" : "Verify Corporate Pass Code"}
                                            </button>
                                        </div>
                                        {giftCouponIsRedeemed === 0 && (
                                            <>
                                                {myCouponStatus && (
                                                    <div className='mb-4 text-wrap bg-green-700 justify-center'>
                                                        <div className="flex flex-col mb-2">
                                                            <div className="flex items-center justify-center">
                                                                <FontAwesomeIcon icon={faGifts} className="text-red-500 text-4xl mr-2" />
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col mb-2">
                                                            <div className="flex items-center justify-center">
                                                                <p className="text-yellow-300">{entityName}</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col mb-2">
                                                            <div className="flex items-center justify-center">
                                                                <p className="text-white">{gifterName}</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col mb-2">
                                                            <div className="flex items-center justify-center">
                                                                <p className="text-yellow-300">{giftMessage}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {myCouponStatus && (
                                                    <div className='mb-4 flex text-wrap justify-center'>
                                                        <button type="button" className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRedeemNow}>Redeem Now</button>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )}
                                </>
                            )}
                            {bookData.isBookClubEnabled && (
                                <>
                                <p className='text-black mt-4'>Any Organisation, Trust, NGO or Group has Provided You a BookClub Token?! Redeem Your Token.</p>
                                <button
                                    type="button"
                                    className="bg-yellow-600 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                    onClick={handleRedeemBookClubTokenClick}
                                    disabled={buyingClicked || hasDiscountCouponClicked || hasReferralCodeClicked || hasFlashReferralCodeClicked || hasRedeemGiftClicked || hasCorpPassClicked || hasPurchased || isFree === 1}
                                >
                                    I have Think5Whys Book Club Token Number
                                </button>
                                {hasBookClubTokenClicked && (
                                    <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-4">
                                        <div className="mb-4">
                                            <div className="mb-4 text-wrap justify-center">
                                                <label htmlFor="giftCouponCode" className="block text-lg text-white text-center">Your 13 Characters Alphanumeric Book Club Token Number:</label>
                                            </div>
                                            <div className="mb-2 flex justify-center">
                                                <input
                                                    type="text"
                                                    name="giftCouponCode"
                                                    id="giftCouponCode"
                                                    value={giftCouponCode}
                                                    placeholder="Input Token Number"
                                                    onChange={(e) => setGiftCouponCode(e.target.value)}
                                                    className="h-12 text-center p-2 border border-gray-300"
                                                />
                                            </div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="flex text-wrap justify-center">
                                                <label htmlFor="corpCode" className="block text-lg text-white">Input 8 digit Think5Whys Book Club ID</label>
                                            </div>
                                            <div className="mb-2 flex justify-center">
                                                <input
                                                    type="text"
                                                    name="corpCode"
                                                    id="corpCode"
                                                    value={corpCode}
                                                    placeholder="Enter Book Club ID"
                                                    onChange={handleBookClubCodeChange}
                                                    className="h-12 text-center p-2 border border-gray-300"
                                                />
                                            </div>
                                            {error && (
                                                <div className="mb-4 flex justify-center">
                                                    <p className="text-red-600 text-center">{error}</p>
                                                </div>
                                            )}
                                        </div>
                                        <div className='mb-4 flex flex-col items-center'>
                                            {myCouponStatus === false && (
                                                <p className={myCouponStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                                                    {couponStatusMsg}
                                                </p>
                                            )}
                                            {myCouponStatus && giftCouponIsRedeemed === 0 && (
                                                <p className={myCouponStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                                                    {couponStatusMsg}
                                                </p>
                                            )}
                                            {giftCouponIsRedeemed === 1 && (
                                                <p className="text-red-600">Sorry! Book Club Token Number {giftCouponCode} has already been Used! Please retry with an Unused Book Club Token Number.</p>
                                            )}
                                            <button
                                                type="button"
                                                className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                onClick={() => {
                                                    giftCouponValidationClicked(giftCouponCode, corpCode, bookId, "BookClubGift", "Book Club Token");
                                                    handleGiftCouponValidation();
                                                }}
                                                disabled={myCouponStatus}
                                            >
                                                {myCouponStatus ? "Verified" : "Verify Book Club Token Number"}
                                            </button>
                                        </div>
                                        {giftCouponIsRedeemed === 0 && (
                                            <>
                                                {myCouponStatus && (
                                                    <div className='mb-4 text-wrap bg-green-700 justify-center'>
                                                        <div className="flex flex-col mb-2">
                                                            <div className="flex items-center justify-center">
                                                                <FontAwesomeIcon icon={faGifts} className="text-red-500 text-4xl mr-2" />
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col mb-2">
                                                            <div className="flex items-center justify-center">
                                                                <p className="text-yellow-300">{entityName}</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col mb-2">
                                                            <div className="flex items-center justify-center">
                                                                <p className="text-white">Gifted By: {gifterName}</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col mb-2">
                                                            <div className="flex items-center justify-center">
                                                                <p className="text-yellow-300">{giftMessage}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {myCouponStatus && (
                                                    <div className='mb-4 flex text-wrap justify-center'>
                                                        <button type="button" className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRedeemNow}>Redeem Now</button>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )}
                                {discountedBuyingClicked && (
                                    <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-2">
                                        <div className="mb-2">
                                            <div className="mb-4 text-lg text-white">
                                                <p>Price to pay: <span className='text-yellow-300'>₹{paymentAmount.toFixed(2)}</span></p>
                                                <p>Think5Whys Purse / Wallet Balance: <span className='text-yellow-300'>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                                {paymentAmount > walletBalanceAmount ? (
                                                    <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                                ) : (
                                                    <p className="text-white">
                                                        After payment your Think5Whys Purse / Wallet balance will be: <span className='text-yellow-300'>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        {walletBalanceAmount < bookData.offerPrice && (
                                            <div className='mb-4 flex text-wrap justify-center'>
                                                <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>
                                            </div>
                                        )}
                                        {walletBalanceAmount >= bookData.offerPrice && (
                                            <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-black text-white mx-auto my-4">
                                                <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                                                <div className="space-y-2 text-gray-700">
                                                <p><strong>Order Number:</strong> {orderNumber}</p>
                                                <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                <p><strong>Customer Name:</strong> {customerName}</p>
                                                <p><strong>Customer Address:</strong> Online Digital Product</p>
                                                <p><strong>Item:</strong> {bookData.bookTitle}</p>
                                                <p><strong>Item Description:</strong> {bookData.bookTitle}</p>
                                                <p className="text-lg font-bold text-green-600"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                                <p className="text-lg font-bold text-green-600"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                                <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                </div>
                                                <div className="flex justify-center mt-6">
                                                <button
                                                    type="button"
                                                    className="bg-green-800 text-white text-xs lg:text-sm w-full py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                                    // onClick={walletPaymentClicked}
                                                    onClick={() => walletPaymentClicked(orderNumber, purchaseDate, customerName, bookData.bookTitle, paymentAmount)}

                                                >
                                                    Confirm Now To Buy. Your Think5Whys Wallet Will Be Charged.
                                                </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                </>
                            )}
                                           
                            <div className='bg-black border border-purple-700 py-2 px-4 flex flex-col justify-center items-center mb-2 w-full'>
                                <div className="details-container mt-2">
                                    <h2 className='text-white text-center text-xs lg:text-sm mb-2'>Spread the joy of reading and share the gift of knowledge with your loved ones by gifting them an this book - a thoughtful and convenient way to inspire and enrich their lives.</h2>
                                </div>
                                <div className="details-container">
                                    <h2 className='text-lime-500 text-lg mb-4 text-center'><FontAwesomeIcon icon={faGifts} className="text-red-500 text-4xl" /></h2>
                                </div>

                                <button onClick={handleGiftIt} className="flex justify-center items-center text-center bg-blue-800 w-24 lg:w-32 text-xs lg:text-sm mb-2" disabled={isFree === 1}>Gift It</button>
                           
                                {giftItClicked && (
                                    <div className="flex flex-col justify-center items-center w-full mx-auto text-white bg-black rounded-lg shadow-lg p-4 mb-4">
                                        <div className="mb-2 text-lg text-white">
                                            <div className='flex flex-col justify-center items-center mb-2 text-wrap '>
                                                <p className='text-white justify-center'>
                                                    Gift Price to pay: <span className='text-yellow-300'>₹{paymentAmount.toFixed(2)}</span>
                                                    {bookData.isPriceInDollarEnabled && (
                                                        <span className='text-white'> (${(paymentAmount*dollarPriceMultiply).toFixed(2)})</span>
                                                    )}
                                                </p>
                                                <p className='text-white'>
                                                    Think5Whys Purse / Wallet Balance:
                                                    <span className='text-yellow-300'>₹{walletBalanceAmount.toFixed(2)}</span>
                                                </p>
                                                {paymentAmount > walletBalanceAmount ? (
                                                    <div className='flex flex-col justify-center items-center'>
                                                        <p className="text-red-500">
                                                            Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}
                                                            {bookData.isPriceInDollarEnabled && (
                                                                <span className='text-white'> ($ to ₹{(((paymentAmount*dollarPriceMultiply*bookData.inrToDollarConversionRate)- walletBalanceAmount)).toFixed(2)})</span>
                                                            )}
                                                        </p>
                                                        <button type="button" className="block w-20 md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>
                                                    </div>
                                                ) : (
                                                    <p className="text-white text-center">
                                                        After payment your Think5Whys Purse / Wallet balance will be: <span className='text-yellow-300'>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className='flex text-wrap justify-center'>
                                                <label htmlFor="giftCouponCode" className="block text-sm lg:text-lg text-white">Your Gift Coupon Code:</label>
                                            </div>
                                            <div className='mb-2 flex justify-center'>
                                                <input
                                                    type="text"
                                                    name="giftCouponCode"
                                                    id="giftCouponCode"
                                                    value={giftCouponCode}
                                                    placeholder={giftCouponCode}
                                                    className='border rounded-md h-10 text-black px-2'
                                                    style={{width: "300px"}}
                                                />
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className='flex text-wrap justify-center'>
                                                <label htmlFor="giftFor" className="text-sm lg:text-lg text-white">Gifting To:</label>
                                            </div>
                                            <div className='mb-2 flex justify-center'>
                                                <input type="text" className='border rounded-md h-10 text-black px-2' style={{width: "250px"}} name="giftFor" id="giftFor" value={giftFor} onChange={e => setGiftFor(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="mb-2 text-white text-m">
                                            <div className='flex text-wrap justify-center'>
                                                <label htmlFor="giftMessage" className="text-sm lg:text-lg text-white">Write Gift Message:</label>
                                            </div>
                                            <div className='flex justify-center'>
                                                <textarea
                                                    type="text"
                                                    name="giftMessage"
                                                    id="giftMessage"
                                                    className="block text-m font-medium bg-gray-700 px-2"
                                                    value={giftMessage}
                                                    placeholder={"Happy reading!! "+giftFor}
                                                    onChange={e => setGiftMessage(e.target.value)}
                                                    style={{ height: '200px', width: "500px" }}
                                                />
                                            </div>
                                        </div>
                                        <div className="mb-2 text-white text-m">
                                            <div className='flex text-wrap justify-center'>
                                                <label htmlFor="gifterSignatureLine" className="text-sm lg:text-lg">Write Signature Line:</label>
                                            </div>
                                            <div className='mb-2 flex text-wrap justify-center'>
                                                <textarea
                                                    type="text"
                                                    name="gifterSignatureLine"
                                                    id="gifterSignatureLine"
                                                    className="block text-m font-medium bg-gray-700 px-2"
                                                    value={gifterSignatureLine}
                                                    placeholder={"I wish you all the best!!"}
                                                    onChange={e => setGifterSignatureLine(e.target.value)}
                                                    style={{ height: '50px', width: "500px" }}
                                                />
                                            </div>
                                        </div>
                                        {!setGiftItErrorMsg && (
                                            <p className='text-red-500'>{giftItErrorMsg}</p>
                                        )}
                                    </div>
                                    
                                )}
                            </div>  
                            {walletBalanceAmount < bookData.offerPrice && (
                                <div className='mb-2 flex text-wrap justify-center'>
                                    <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>
                                </div>
                            )}
                            {walletBalanceAmount >= bookData.offerPrice && (
                                <div className="flex flex-col p-2 border-2 border-yellow-400 rounded-lg shadow-lg bg-black text-white mx-auto my-4">
                                    <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                                    <div className="space-y-2 text-gray-700">
                                    <p><strong>Order Number:</strong> {orderNumber}</p>
                                    <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                    <p><strong>Customer Name:</strong> {customerName}</p>
                                    <p><strong>Customer Address:</strong> Online Digital Product</p>
                                    <p><strong>Item:</strong> {bookData.bookTitle}</p>
                                    <p><strong>Item Description:</strong> {bookData.bookTitle}</p>
                                    <p className="text-lg font-bold text-green-600"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                    <p className="text-lg font-bold text-green-600"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                    <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                    </div>
                                    <div className="flex justify-center mt-6">
                                    <button
                                        type="button"
                                        className="bg-green-800 text-white text-xs lg:text-sm w-full py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                        onClick={handleGiftNowByWallet}
                                    >
                                        Confirm Now To Buy for Gifting. Your Think5Whys Purse / Wallet Will Be Dedcuted.
                                    </button>
                                    </div>
                                </div>
                            )}                                                          
                        </>
                    )}
                    {bookData.amazonLink != "" && (
                        <div className='mt-1'>
                            <button
                                disabled={hasPurchased || isFree === 1}
                                onClick={() => window.open(bookData.amazonLink, "_blank")}
                                style={{ maxWidth: '200px' }}
                                className="amazon-button">
                                Buy On Amazon
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <footer className="bg-black border-t border-blue-400 text-white py-4">
                <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-sm text-yellow-200">© 2025 Think5Whys Global DeepTech Solutions.</div>
                    <div className="flex flex-wrap gap-4 text-sm">
                        <Link to="/about-us" className="hover:text-teal-300">About</Link>
                        <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
                        <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
                        <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
                    </div>
                </div>
            </footer>
        </div >
    );
};

export default BuyingBookDetails;
